export const STATS_ROUTES = {
    1: "/transactions/recharge-transactions",
    2: "/reports/admin-profit-report",
    18: "/accounting/vendor-payments",
    22: "/transactions/disputed-recharge-transactions",
    23: "/reports/api-summary-book",
    24: "/accounting/fund-requests",
    11: "/transactions/recharge-transactions",
    12: "/transactions/recharge-transactions",
    21: "/transactions/pending-recharge-transactions",
    19: "/transactions/recharge-transactions",
    20: "/reports/admin-profit-report",
    16: "/accounting/fund-transfers",
    17: "/accounting/fund-transfers",
    13: "/accounting/fund-requests",
    3: "/accounts-management/accounts",
    5: "/accounts-management/accounts",
    7: "/accounts-management/accounts",
    9: "/accounts-management/accounts",
    14: "/accounting/fund-requests",
    15: "/accounting/fund-requests",
    4: "/accounts-management/accounts",
    6: "/accounts-management/accounts",
    8: "/accounts-management/accounts",
    10: "/accounts-management/accounts",
};
